import { useAtomValue } from 'jotai';
import type { Rect } from '@view-model/models/common/basic';
import { faXmark } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { viewTitleBarAtom } from './viewTitlaBarAtom';

type Props = {
  viewRect: Rect;
  width: number;
  onClickCloseButton: () => void;
};

export const MeaningPanelTitleBar: React.FC<Props> = ({ viewRect, width, onClickCloseButton }: Props) => {
  const {
    title: { fontSize },
    height,
    margin,
    menu: { buttonSize },
  } = useAtomValue(viewTitleBarAtom);
  return (
    <g transform={viewRect.topLeft().toSVGTranslate()}>
      <rect
        width={width}
        height={height}
        rx={height / 2}
        ry={height / 2}
        x={0}
        y={-height - margin * 2}
        stroke="#a0aec0"
        strokeWidth={2}
        fill={'white'}
      />
      <foreignObject
        width={width}
        height={height}
        transform={`translate(0, ${-height - margin * 2})`}
        className="pointer-events-none"
      >
        <div className={'flex items-center gap-8 px-16 text-[80px]'} style={{ height }}>
          <div className={'grow truncate text-center font-bold'} style={{ fontSize }}>
            意味の構造・説明
          </div>
          <div className={'flex shrink-0 flex-row flex-nowrap items-center justify-end'}>
            <div onClick={onClickCloseButton} style={{ width: buttonSize, height: buttonSize, pointerEvents: 'auto' }}>
              <div className={'flex size-full cursor-pointer items-center justify-center rounded-lg font-bold'}>
                <FontAwesomeIcon icon={faXmark} style={{ fontSize }} color={'#a0aec0'} />
              </div>
            </div>
          </div>
        </div>
      </foreignObject>
    </g>
  );
};
